import React from 'react';

const TitleScreen = ({ onStart, onResume, hasResume, onMulti, onBattle }) => (
  <div className="glass-card">
    <h1 style={{ 
      fontSize: '4.5rem', 
      color: 'var(--primary-blue)', 
      margin: '0 0 5px 0',
      fontWeight: '900'
    }}>
      QAssist
    </h1>
    
    <p style={{ 
      color: '#95a5a6', 
      fontSize: '1.2rem', 
      marginBottom: '45px',
      letterSpacing: '0.1em'
    }}>
      サブプリントクイズ
    </p>
    
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '10px' }}>
      <button className="playful-btn" onClick={() => onStart('solo')}>
        ひとりで学習
      </button>

      {hasResume && (
        <button
          className="playful-btn"
          style={{ background: '#2ecc71' }}
          onClick={onResume}
        >
          前回の続きから
        </button>
      )}
      
      <button 
        className="playful-btn" 
        style={{ background: '#e67e22' }}
        onClick={onMulti}
      >
        みんなで学習
      </button>

      <button 
        className="playful-btn" 
        style={{ background: '#e74c3c' }}
        onClick={onBattle}
      >
        みんなで対決
      </button>
    </div>
  </div>
);

export default TitleScreen;